// src/index.js
import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.min.css";
import "./sass/default.scss";

import App from "./App";
import { LanguageProvider } from "./contexts/LanguageContext";
import { ProContextProvider } from "./contexts/ProContext";
import { OwnerQaProvider } from "./contexts/OwnerQaContext";
import { UserContextProvider } from "./contexts/UserContext";

// ✅ Get root container once
const container = document.getElementById("root");
if (!container) throw new Error("No se encontró el elemento #root");

// ✅ Avoid creating root multiple times (Fast Refresh safe)
const root = container.__reactRoot ?? createRoot(container);
container.__reactRoot = root;

root.render(
  <React.StrictMode>
    <LanguageProvider>
      <UserContextProvider>
        <OwnerQaProvider>
          <ProContextProvider>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </ProContextProvider>
        </OwnerQaProvider>
      </UserContextProvider>
    </LanguageProvider>
  </React.StrictMode>,
);
